import { render, staticRenderFns } from "./v-take-photo.vue?vue&type=template&id=54c0a518&scoped=true&"
import script from "./v-take-photo.vue?vue&type=script&lang=js&"
export * from "./v-take-photo.vue?vue&type=script&lang=js&"
import style0 from "./v-take-photo.vue?vue&type=style&index=0&id=54c0a518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0a518",
  null
  
)

export default component.exports